export enum PDPTemplate {
  PDPV2 = 'PDP V2',
  PDPV2Light = 'PDP V2 Light',
  Grill = 'ZR Grill PDP',
  NonGrillDark = 'ZR Non-Grill Dark',
  NonGrillLight = 'ZR Non-Grill Light',
  TierOne = 'Tier 1',
  TierTwo = 'Tier 2',
  TierThree = 'Tier 3',
  Default = 'default',
}

export const isTierOne = (template: PDPTemplate): boolean =>
  template === PDPTemplate.TierOne || template === PDPTemplate.Grill;

export const isTierTwo = (template: PDPTemplate): boolean =>
  template === PDPTemplate.TierTwo || 
  template === PDPTemplate.NonGrillLight || 
  template === PDPTemplate.NonGrillDark;
